import { useEffect, useState } from 'react';

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion(): boolean {
    return (
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia(REDUCED_MOTION_QUERY).matches
    );
}

/**
 * Suit la préférence système « réduire les animations » (WCAG 2.2.2 / 2.3.3).
 */
const usePrefersReducedMotion = (): boolean => {
    const [reducedMotion, setReducedMotion] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return undefined;
        }
        const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
        const onChange = () => {
            setReducedMotion(mediaQuery.matches);
        };
        onChange();
        mediaQuery.addEventListener('change', onChange);
        return () => {
            mediaQuery.removeEventListener('change', onChange);
        };
    }, [setReducedMotion]);

    return reducedMotion;
};

export default usePrefersReducedMotion;
